import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl mb-4" }
const _hoisted_2 = { class: "pb-4 mb-4 p-4 border-b" }
const _hoisted_3 = { class: "px-4 pb-2 grid grid-cols-1 gap-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-2 gap-x-6"
}
const _hoisted_5 = {
  key: 2,
  class: "grid grid-cols-1 gap-x-6"
}
const _hoisted_6 = { class: "relative mt-1.5" }
const _hoisted_7 = { class: "absolute left-0 bottom-0 px-4 py-2" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = {
  key: 0,
  class: "flex gap-x-4 items-center"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-600" }, " Template Pesan : ", -1)
const _hoisted_11 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-2 text-gray-700" }
const _hoisted_12 = { class: "text-12px text-gray-lp-500" }
const _hoisted_13 = {
  key: 0,
  class: "text-12px text-gray-lp-500 py-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagingServiceConfigurationDictionary = _resolveComponent("MessagingServiceConfigurationDictionary")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MessageVariables = _resolveComponent("MessageVariables")!
  const _component_content_edit_able = _resolveComponent("content-edit-able")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      title: "Shortcode",
      modelValue: _ctx.dialogDictionary,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogDictionary = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MessagingServiceConfigurationDictionary)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { label: "Detail Pesan" }),
      _createTextVNode(" " + _toDisplayString(_ctx.watchMessageType), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.isMessageTypeWhatsappPremium)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              label: "Template Pesan",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: "Masukan template pesan",
                  modelValue: _ctx.form.messageDetail,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.messageDetail = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.form.messageType === 'wa_premium')
        ? (_openBlock(), _createBlock(_component_MessageVariables, {
            key: 1,
            modelValue: _ctx.form.msgConfMeta,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.msgConfMeta = $event)),
            onOpenDictionary: _ctx.showDictionary
          }, null, 8, ["modelValue", "onOpenDictionary"]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              label: "Isi Pesan",
              asterisk: !_ctx.isMessageTypeWhatsappPremium
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_content_edit_able, {
                    tag: "div",
                    class: ["outline-none overflow-y-auto focus:shadow border border-gray-lp-400 rounded pt-2 pb-16 px-4", 
                `${
                  _ctx.isMessageTypeWhatsappPremium
                    ? 'text-gray-lp-600'
                    : 'text-black-lp-300'
                }`
              ],
                    contenteditable: !_ctx.isMessageTypeWhatsappPremium,
                    "model-value": _ctx.form.messageDetail,
                    "onUpdate:modelValue": _ctx.onInputMessage,
                    onKeydown: _ctx.validateInput
                  }, null, 8, ["class", "contenteditable", "model-value", "onUpdate:modelValue", "onKeydown"]),
                  (!_ctx.isMessageTypeWhatsappPremium)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("div", _hoisted_8, [
                            (_ctx.isTemplateAvailable)
                              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                  _hoisted_10,
                                  _createVNode(_component_lp_button, {
                                    onClick: _ctx.fillWithTemplate,
                                    compact: "",
                                    "custom-class": "py-1 px-3",
                                    "text-color": "red-lp-400",
                                    outline: "",
                                    title: _ctx.titleAvailableTemplate
                                  }, null, 8, ["onClick", "title"]),
                                  _createVNode(_component_lp_button, {
                                    onClick: _ctx.showDictionary,
                                    compact: "",
                                    "custom-class": "py-1 px-3",
                                    icon: "book"
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.form.messageDetail.length) + "/" + _toDisplayString(this.maxLengthMessage), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.form.messageType.includes('sms'))
                  ? (_openBlock(), _createBlock("div", _hoisted_13, " Maksimalkan isi pesan SMS dengan 160 karakter "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["asterisk"])
          ]))
    ])
  ]))
}